import React, { useCallback, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import {
  AppstoreOutlined,
  BarChartOutlined,
  CloudOutlined,
  ShopOutlined,
  TeamOutlined,
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { Layout, Typography, theme, Button, notification } from 'antd';
import './App.css';

import { HeaderMainDiv, HeaderMainDivLeft, HeaderMainDivRight, Logo, PageName } from './AdminLayoutStyle';
import SidebarMenu from './atoms/SiderbarMenu';
const { Header, Content, Sider } = Layout;
const items = [
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  BarChartOutlined,
  CloudOutlined,
  AppstoreOutlined,
  TeamOutlined,
  ShopOutlined,
].map((icon, index) => ({
  key: String(index + 1),
  icon: React.createElement(icon),
  label: `nav ${index + 1}`,
}));

function AdminLayout({ headerData, setHeaderData }) {
  const [collapsed, setCollapsed] = useState(false);
  const handleToggle = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);
  const navigate = useNavigate();
  const {
    token: { colorBgContainer, colorBgLayout, colorPrimaryBg },
  } = theme.useToken();

  const handleLogout = () => {
    localStorage.removeItem('token');
    notification.success({
      message: 'You are logged out successfully.',
      placement: 'bottomRight',
    });
    navigate('/login');
  };

  return (
    <Layout hasSider>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          background: colorBgContainer,
          borderRight: '1px solid #dbe0e6',
        }}
      >
        <Logo
          className='demo-logo-vertical'
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <img src='/pos.svg' alt='image' style={{ width: collapsed ? 40 : 200, height: collapsed ? 40 : 66 }} />
        </Logo>
        <SidebarMenu />
      </Sider>
      <Layout className='site-layout' style={{ marginLeft: collapsed ? 80 : 200, background: '#eff3f7' }}>
        <Header
          style={{
            position: 'sticky',
            top: 0,
            padding: 0,
            zIndex: 1,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: colorBgContainer,
            borderBottom: '1px solid #dbe0e6',
            height: 66,
          }}
        >
          {/* <HeaderMainDiv> */}
          <HeaderMainDivLeft>
            <Button
              type='text'
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={handleToggle}
              style={{
                fontSize: '16px',
                width: 64,
                height: 64,
              }}
            />
            <PageName>{headerData.pageName}</PageName>
          </HeaderMainDivLeft>
          <HeaderMainDivRight>
            <PageName>
              <Button type='ghost' name='Logout' onClick={handleLogout}>
                <PageName>Logout</PageName>
              </Button>
            </PageName>
          </HeaderMainDivRight>
          {/* </HeaderMainDiv> */}
        </Header>

        <Content
          style={{
            padding: 24,
            minHeight: 280,
            backgroundColor: '#eff3f7',
          }}
        >
          <Outlet context={{ setHeaderData }} />
        </Content>
      </Layout>
    </Layout>
  );
}

export default React.memo(AdminLayout);
